import { Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const deletedAtProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'deletedAt',
  title: i18n.t('documents.employee.list.deleted_at'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ deletedAt }) => <Text size="200">{dateBackendDateTimeToUI(deletedAt)}</Text>,
  sortBy: 'deletedAt',
  colSpan: 1,
})

export default deletedAtProjection
